package com.arena_web.ui.components.navigation

import androidx.compose.runtime.Composable
import com.arena_web.ui.components.icons.Icon
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

enum class BusinessSidebarTab(val label: String, val icon: String, val route: String) {
    Dashboard("Dashboard", AppIcons.Dashboard, "/dashboard"),
    Clients("Clients", AppIcons.People, "/clients"),
    Chat("Chat", AppIcons.Chat, "/chat"),
    Schedule("Schedule", AppIcons.Calendar, "/schedule"),
    ClubSettings("Club Settings", AppIcons.Settings, "/settings")
}

@Composable
fun BusinessSidebarNav(
    activeTab: BusinessSidebarTab? = null,
    onTabSelected: (BusinessSidebarTab) -> Unit = {}
) {
    val t = LocalAppStrings.current
    fun tabLabel(tab: BusinessSidebarTab): String = when (tab) {
        BusinessSidebarTab.Dashboard -> t.navDashboard
        BusinessSidebarTab.Clients -> t.navClients
        BusinessSidebarTab.Chat -> t.navChat
        BusinessSidebarTab.Schedule -> t.navSchedule
        BusinessSidebarTab.ClubSettings -> t.navClubSettings
    }
    Row(
        Modifier.styleModifier { property("gap", s(4)) },
        verticalAlignment = Alignment.CenterVertically
    ) {
        BusinessSidebarTab.entries.forEach { tab ->
            if (tab == activeTab) {
                Row(
                    Modifier
                        .sHeight(48)
                        .sBorderRadius(28)
                        .backgroundColor(AppColors.Primary)
                        .sPadding(8, 18)
                        .overflow(Overflow.Hidden)
                        .styleModifier {
                            property("box-shadow", "0px 4px 4px 0px rgba(0, 0, 0, 0.25)")
                            property("cursor", "pointer")
                            property("gap", s(8))
                        }
                        .onClick { onTabSelected(tab) },
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        src = tab.icon,
                        modifier = Modifier.styleModifier {
                            property("filter", "brightness(0) invert(1)")
                        }
                    )
                    SpanText(
                        tabLabel(tab),
                        modifier = Modifier
                            .bodyLMedium()
                            .color(AppColors.PrimaryWhite)
                    )
                }
            } else {
                Box(
                    Modifier
                        .sSize(48)
                        .sBorderRadius(100)
                        .overflow(Overflow.Hidden)
                        .styleModifier {
                            property("border", "0.3px solid transparent")
                            property("background",
                                "${AppGradients.InteractiveSecondary} padding-box, " +
                                "linear-gradient(0deg, var(--arena-bg), var(--arena-bg)) padding-box, " +
                                "${AppGradients.ButtonBorderGradientPrimary} border-box")
                            property("cursor", "pointer")
                        }
                        .onClick { onTabSelected(tab) },
                    contentAlignment = Alignment.Center
                ) {
                    Icon(src = tab.icon)
                }
            }
        }
    }
}
